// extracted by mini-css-extract-plugin
export var pageTocMobileButton = "PageTOC-module--page-toc-mobile-button--bc781";